import { render, staticRenderFns } from "./listDesc.vue?vue&type=template&id=1ca81b15&scoped=true&"
import script from "./listDesc.vue?vue&type=script&lang=js&"
export * from "./listDesc.vue?vue&type=script&lang=js&"
import style0 from "./listDesc.vue?vue&type=style&index=0&id=1ca81b15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca81b15",
  null
  
)

export default component.exports